import { initContract } from '@ts-rest/core';
const c = initContract();
export const NO_GROUP_TOKEN = 'NO_GROUP';
export const sharedKnowledgeFileContract = c.router({
    uploadFile: {
        method: 'POST',
        path: 'admin/shared-knowledge/upload-file',
        summary: 'Upload a file',
        responses: {
            200: c.type(),
            400: c.type(),
            413: c.type(),
        },
        body: c.noBody(),
    },
    uploadFiles: {
        method: 'POST',
        path: 'admin/shared-knowledge/upload-files',
        summary: 'Upload multiple files',
        responses: {
            200: c.type(),
            400: c.type(),
            413: c.type(),
        },
        body: c.noBody(),
    },
    getFiles: {
        method: 'GET',
        path: '/admin/shared-knowledge/files',
        query: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    getFileById: {
        method: 'GET',
        path: '/admin/shared-knowledge/files/:id',
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    deleteFile: {
        method: 'DELETE',
        path: '/admin/shared-knowledge/files/:id',
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    updateGroup: {
        method: 'POST',
        path: '/admin/shared-knowledge/groups/:id',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    deleteGroup: {
        method: 'DELETE',
        path: '/admin/shared-knowledge/groups/:id',
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    createGroup: {
        method: 'POST',
        path: '/admin/shared-knowledge/groups',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    updateFile: {
        method: 'POST',
        path: '/admin/shared-knowledge/update-file',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    getFilesForCitation: {
        method: 'GET',
        path: '/shared-knowledge/files-for-citation',
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    bulkUpdateFiles: {
        method: 'PUT',
        path: '/admin/shared-knowledge/files/bulk-update',
        summary: 'Bulk update multiple files with groups',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    getGroupsPublic: {
        method: 'GET',
        path: '/shared-knowledge/groups',
        summary: 'Get all shared knowledge groups (public route)',
        responses: {
            200: c.type(),
            500: c.type(),
        },
    },
    deleteManyFiles: {
        method: 'DELETE',
        path: '/admin/shared-knowledge/files',
        summary: 'Delete multiple files',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
});
//# sourceMappingURL=sharedKnowledgeFile.js.map